var render, staticRenderFns
import script from "./CrtUser.vue?vue&type=script&lang=js&"
export * from "./CrtUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3adf24f9')) {
      api.createRecord('3adf24f9', component.options)
    } else {
      api.reload('3adf24f9', component.options)
    }
    
  }
}
component.options.__file = "src/views/User/Crud/CrtUser.vue"
export default component.exports